<app-breadcrumb></app-breadcrumb>

<div class="card mb-0">
    <div class="card-body">
        <div class="row align-items-center">
            <div class="col-auto">
                <div class="input-group input-group-sm w-auto">
                    <select class="form-control form-control-sm"
                        [(ngModel)]="selectedHourFrom"
                        (ngModelChange)="changeSearchHourFrom($event)">
                        <option *ngFor="let item of listHour;" [ngValue]="item">{{item}} 시</option>
                    </select>
                    <select class="form-control form-control-sm"
                        [(ngModel)]="selectedMinuteFrom"
                        (ngModelChange)="changeSearchMinuteFrom($event)">
                        <option *ngFor="let item of listMinute;" [ngValue]="item">{{item}} 분</option>
                    </select>
                    <div class="input-group-append align-items-center">
                        <span class="input-group-text">부터</span>
                    </div>
                </div>
            </div>
            <div class="col-auto">
                <div class="input-group input-group-sm w-auto">
                    <select class="form-control form-control-sm"
                        [(ngModel)]="selectedHourTo"
                        (ngModelChange)="changeSearchHourTo($event)">
                        <option *ngFor="let item of listHour;" [ngValue]="item">{{item}} 시</option>
                    </select>
                    <select class="form-control form-control-sm"
                        [(ngModel)]="selectedMinuteTo"
                        (ngModelChange)="changeSearchMinuteTo($event)">
                        <option *ngFor="let item of listMinute;" [ngValue]="item">{{item}} 분</option>
                        <option [ngValue]="59">59 분</option>
                    </select>
                    <div class="input-group-append align-items-center">
                        <span class="input-group-text">까지</span>
                    </div>
                </div>
            </div>
            <div class="col-auto">
                <div class="input-group input-group-sm w-auto">
                    <div class="input-group-prepend align-items-center">
                        <span class="input-group-text">표시</span>
                    </div>
                    <select class="form-control form-control-sm"
                        [(ngModel)]="selectedFilterMin"
                        (ngModelChange)="changeFilterMin($event)">
                        <option *ngFor="let item of listFilterMin;" [ngValue]="item">{{item}} 분 단위</option>
                        <!-- <option [ngValue]="0">전체</option> -->
                    </select>
                </div>
            </div>
            <div class="col"></div>
            <div class="col-auto">
                <button type="button" class="btn btn-sm btn-outline-success"
                    (click)="exportExcel()">
                    <i class="fas fa-file-excel"></i>
                    <span class="ml-1">엑셀출력</span>
                </button>
            </div>
        </div>

        <div class="table-responsive mt-3 overflow-auto" style="max-height: 480px;">
            <table class="table table-sm table-hover align-items-center mb-0 text-nowrap" #tblTemper>
                <thead>
                    <tr class="text-center">
                        <th style="width:80px;">
                            순번
                        </th>
                        <th style="width:200px;">
                            운행일시
                        </th>
                        <th style="width:80px;">
                            온도1(℃)
                        </th>
                        <th style="width:80px;">
                            온도2(℃)
                        </th>
                        <th>
                            비고
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of listItem;let idx = index;" class="text-center">
                        <td>
                            {{idx + 1}}
                        </td>
                        <td>
                            {{item.dtgRegDt}}
                        </td>
                        <td>
                            {{item.dtgTemper1 | number:'0.1'}}
                        </td>
                        <td>
                            {{item.dtgTemper2 | number:'0.1'}}
                        </td>
                        <td>
                            -
                        </td>
                    </tr>
                    <tr class="text-center" *ngIf="!listItem || listItem.length === 0">
                        <td colspan="5">
                            표시 할 데이터가 없습니다
                        </td>
                    </tr>
                </tbody>
            </table>
            <!-- <table class="table table-sm table-hover table-borderless align-items-center mb-0" #tblTemper>
                <tbody>
                    <tr class="text-center">
                        <th colspan="5" class="border">
                            온도 기록 일지
                        </th>
                    </tr>
                    <tr class="text-center">
                        <th class="border bg-light">
                            차량번호
                        </th>
                        <th colspan="2" class="border">
                            {{dtgCarNo}}
                        </th>
                        <th class="border bg-light">
                            기록단위
                        </th>
                        <th class="border">
                            {{selectedFilterMin}}분
                        </th>
                    </tr>
                    <tr class="text-center">
                        <th class="border bg-light">
                            기록기간
                        </th>
                        <th colspan="4" class="border">
                            <span>
                                {{selectedYear}}-{{selectedMonth | number:'2.0'}}-{{selectedDay | number:'2.0'}}
                            </span>
                            &nbsp;
                            <span class="">
                                {{selectedHourFrom | number:'2.0'}}:{{selectedMinuteFrom | number:'2.0'}}
                            </span>
                            &nbsp;
                            <span class="">~</span>
                            &nbsp;
                            <span>
                                {{selectedYear}}-{{selectedMonth | number:'2.0'}}-{{selectedDay | number:'2.0'}}
                            </span>
                            &nbsp;
                            <span class="">
                                {{selectedHourTo | number:'2.0'}}:{{selectedMinuteTo | number:'2.0'}}
                            </span>
                        </th>
                    </tr>
                    <tr class="text-center">
                        <td colspan="5">
                            &nbsp;
                        </td>
                    </tr>
                    <tr class="text-center">
                        <th class="border bg-light" style="width:80px;">
                            순번
                        </th>
                        <th class="border bg-light">
                            운행일시
                        </th>
                        <th class="border bg-light" style="width:80px;">
                            온도1(℃)
                        </th>
                        <th class="border bg-light" style="width:80px;">
                            온도2(℃)
                        </th>
                        <th class="border bg-light">
                            비고
                        </th>
                    </tr>
                    <tr *ngFor="let item of listItem;let idx = index;" class="text-center">
                        <td class="border">
                            {{idx + 1}}
                        </td>
                        <td class="border">
                            {{item.dtgRegDt}}
                        </td>
                        <td class="border">
                            {{item.dtgTemper1 | number:'0.1'}}
                        </td>
                        <td class="border">
                            {{item.dtgTemper2 | number:'0.1'}}
                        </td>
                        <td class="border">
                            &nbsp;
                        </td>
                    </tr>
                </tbody>
            </table> -->
        </div>

        <!-- <div class="mt-3">
            <list-paging
                [inputPagingInfo]="pagingInfo"
                (callbackClickPageNumber)="callbackClickPageNumber($event)"
                (callbackChangeCountRowPerPage)="callbackChangeCountRowPerPage($event)"></list-paging>
        </div> -->
    </div>
</div>